'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _email = require('./email.controller');

var _email2 = _interopRequireDefault(_email);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('advinda.email.controllers', []).controller('EmailController', _email2.default);


/** WEBPACK FOOTER **
 ** ./src/app/components/email/email.controllers.js
 **/